export default "__VITE_ASSET__BROsCIb8__"